import {Injectable} from '@angular/core';
import {Observable, Subject} from "rxjs";
import {MatSnackBar} from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private primarySpinner = false;
  private spinnerStatus: boolean = false;
  private spinnerSubject: Subject<boolean> = new Subject<boolean>();
  spinner$: Observable<boolean> = this.spinnerSubject.asObservable();

  constructor(private matSnackBar: MatSnackBar) {
  }

  startSpinner(): void {
    if (!this.spinnerStatus) {
      this.spinnerStatus = true;
      this.spinnerSubject.next(true)
    }
  }

  startPrimarySpinner(): void {
    if (!this.primarySpinner) {
      this.spinnerStatus = true;
      this.primarySpinner = true;
      this.spinnerSubject.next(true)
    }
  }

  stopSpinner() {
    if (this.primarySpinner) {
      return;
    }

    if (this.spinnerStatus) {
      this.spinnerStatus = false;
      this.spinnerSubject.next(false)
    }
  }

  stopPrimarySpinner(): void {
    if (this.primarySpinner) {
      this.spinnerStatus = false;
      this.primarySpinner = false;
      this.spinnerSubject.next(false)
    }
  }

  stopSpinnerWithSuccess(successMsg: string) {
    if (this.spinnerStatus) {
      this.spinnerStatus = false;
      this.spinnerSubject.next(false);
    }
    this.matSnackBar.dismiss(); // Voorkomt herhaling
    this.matSnackBar.open(successMsg, '', {
      verticalPosition: "top",
      duration: 3500, // 3.5 seconds
      panelClass: 'ehr-green-snack-bar'
    })
  }

  stopSpinnerWithError(errorMsg: string) {
    if (this.spinnerStatus) {
      this.spinnerStatus = false;
      this.spinnerSubject.next(false);
    }
    this.matSnackBar.dismiss(); // Voorkomt herhaling
    this.matSnackBar.open(errorMsg, '', {
      panelClass: 'ehr-red-snack-bar',
      verticalPosition: "top",
      duration: 3500, // 3.5 seconds
    })
  }
}
